import { Hourglass } from 'lucide-react'
import './Waitlist.css'

const DISCORD_GROUP_URL = import.meta.env.VITE_DISCORD_GROUP_URL as string | undefined

export function Waitlist() {
  return (
    <div className="waitlist">
      <div className="waitlist-card">
        <div className="waitlist-badge">
          <span className="waitlist-badge-dot" aria-hidden="true" />
          En revisi&oacute;n
        </div>

        <div className="waitlist-icon" aria-hidden="true">
          <Hourglass size={64} />
        </div>

        <h1>Est&aacute;s en la lista de espera</h1>
        <p className="waitlist-lead">
          Tu cuenta fue recibida y est&aacute; siendo revisada por nuestro equipo.
          Para que podamos aprobarte m&aacute;s r&aacute;pido, unite a nuestro grupo de
          Discord y avisanos que est&aacute;s en la lista.
        </p>

        <div className="waitlist-steps">
          <div className="waitlist-step">
            <span className="waitlist-step-num">1</span>
            <span>Unite al grupo de Discord</span>
          </div>
          <div className="waitlist-step">
            <span className="waitlist-step-num">2</span>
            <span>Escribenos para confirmar tu solicitud</span>
          </div>
          <div className="waitlist-step">
            <span className="waitlist-step-num">3</span>
            <span>Recibir&aacute;s acceso completo una vez aprobado</span>
          </div>
        </div>

        <div className="waitlist-actions">
          {DISCORD_GROUP_URL ? (
            <a
              href={DISCORD_GROUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="discord-button"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.317 4.37a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.058a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
              </svg>
              Unirse al grupo de Discord
            </a>
          ) : (
            <div className="waitlist-warning">
              La URL del grupo de Discord no est&aacute; configurada. Contactanos para
              recibir el enlace.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}